import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import MainLogo from '@/materials/atoms/MainLogo.vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(MainLogo, {
                id: "main_logo",
                class: "keyframe animation"
            }));
        };
    }
});
